"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loading = function (_a) {
    var type = _a.type, showLoadingText = _a.showLoadingText;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: type + "-loader" }),
        showLoadingText && react_1.default.createElement("p", { className: "loading-text" }, "Loading...")));
};
exports.default = Loading;
